import { GetStartedSectionById } from "@queries/entries/GetStartedSectionById";
import { ResultOf } from "gql.tada";
import { GetStartedForm } from "./GetStartedForm";
import { BackgroundBlob } from "@components/shared/BackgroundBlob";
import { useState } from "react";
import { GetStartedSubmission } from "./GetStartedSubmission";
import { MarkdownLite } from "@components/shared/MarkdownLite";

export const GetStartedSection = ({
  entry: { getStartedSection: entry },
}: {
  entry: ResultOf<typeof GetStartedSectionById>;
}) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  if (!entry) return;

  if (isSubmitted) return <GetStartedSubmission entry={entry} />;

  return (
    <section className="mb-20 mt-20 relative">
      <BackgroundBlob />
      <div className="flex flex-col container-base dsk:grid-base">
        <div className="col-start-2 col-span-8">
          <div className="dsk:sticky top-16">
            {entry?.title && <h1 className="text-heading-2">{entry?.title}</h1>}
            <p className="text-body-regular my-10">
              <MarkdownLite>{entry?.description ?? ""}</MarkdownLite>
            </p>
          </div>
        </div>
        <GetStartedForm
          entry={entry}
          onSubmitSuccess={() => setIsSubmitted(true)}
          className="col-start-12 col-end-24"
        />
      </div>
    </section>
  );
};
